<template>

    <draggable v-model="valueTemp"
               group="branches"
               v-bind="{handle:'.branches-handle', animation:150}">

        <b-container v-for="branch in valueTemp" 
                     :key="branch.Id" 
                     class="m-15-0">

            <b-row class="m-0 p-0 v-center">

                <b-col md="auto" class="m-0 p-0" @click="branch.toogleShow()">
                    
                    <font-awesome-icon icon="caret-down" 
                                       size="2x" 
                                       color="#00af00"
                                       id="sorting-list-caret"
                                       :class="branch.IsShow ? 'sorting-list-caret-up' : 'sorting-list-caret-down'" />
                </b-col>

                <b-col md="auto" class="sorting-list-name m-0 p-0" style="color: #00af00">
                    {{branch.Name}}
                </b-col>

                <b-col md="auto" 
                       class="m-0 p-0" 
                       @click="openNavigator(branch)">

                    <font-awesome-icon icon="location-arrow" class="sorting-icon pointer"/>
                </b-col>

                <b-col md="auto" class="branches-handle m-0 p-0">
                    <font-awesome-icon icon="arrows-alt" class="sorting-icon pointer" />
                </b-col>

            </b-row>

            <hr class="hr-parent">

            <transition name="visibility-switch">
                <region-list v-if="branch.IsShow" 
                             v-model="branch.Regions"
                             @update="setIsUpdateSorting" />
            </transition>

        </b-container>

    </draggable>


</template>

<script>

import RegionList from './RegionList'

export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        valueTemp: {
            get: function() {
                return this.value;
            },
            set: function(val) {
                this.$emit('update', val)
            }
        }
    },
    methods: {
        setIsUpdateSorting: function() {
            this.$emit('update', this.valueTemp);
        },
        openNavigator: function(branch) {
            window.open(`https://yandex.ru/maps/?text=${branch.Location.Latitude}%2C%20%20${branch.Location.Longitude}`);
        }
    },
    components: {
        RegionList
    }
}
</script>